var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpChevron24Px = function SvgUpChevron24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 15.41L12 10.83L7.41 15.41L6 14L12 8L18 14L16.59 15.41Z",
    fill: "white"
  })));
};
export { SvgUpChevron24Px as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjU5IDE1LjQxTDEyIDEwLjgzTDcuNDEgMTUuNDFMNiAxNEwxMiA4TDE4IDE0TDE2LjU5IDE1LjQxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";